<template>
  <v-col>
    <v-autocomplete
      :items="trainTypes"
      :rules="[required]"
      outlined
      label="Tågtyp"
      v-model="type"
    />
  </v-col>
</template>

<script>
import { sync } from 'vuex-pathify'
import trainTypes from '@/common/trainTypes'
import { required } from '@/common/validationRules'

export default {
  name: 'DelayTypeField',

  data: () => ({
    required,
    trainTypes
  }),

  computed: {
    type: sync('delay/model@type')
  }
}
</script>
